import _objectSpread from "@babel/runtime/helpers/objectSpread2";
import _classCallCheck from "@babel/runtime/helpers/classCallCheck";
import _createClass from "@babel/runtime/helpers/createClass";
import _inherits from "@babel/runtime/helpers/inherits";
import _createSuper from "@babel/runtime/helpers/createSuper";
import _isPlainObject from "lodash/isPlainObject";
import "core-js/modules/es6.object.keys.js";
import "core-js/modules/es6.regexp.search.js";

/*
 * Copy of https://github.com/NerdWallet/nw-client-lib/blob/master/src/tracking/components/click.jsx
 *
 */
import React from 'react';
import PropTypes from 'prop-types';
import qs from 'querystring';
import uri from 'url'; // eslint-disable-next-line lodash/import-scope -- directive added automatically by Shepherd migration, import/no-extraneous-dependencies

var wrapWithClickProps = function wrapWithClickProps(defaultComponent) {
  var ApplyNowClick = /*#__PURE__*/function (_React$Component) {
    _inherits(ApplyNowClick, _React$Component);

    var _super = _createSuper(ApplyNowClick);

    function ApplyNowClick(props) {
      var _this;

      _classCallCheck(this, ApplyNowClick);

      _this = _super.call(this, props);
      _this.state = {
        header_pageViewId: null
      };
      return _this;
    }

    _createClass(ApplyNowClick, [{
      key: "componentDidMount",
      value: function componentDidMount() {
        // Only let clients that execute JS see pageviewid
        this.setState({
          header_pageViewId: this.getPageViewId()
        });
      }
    }, {
      key: "getPageViewId",
      value: function getPageViewId() {
        // eslint-disable-next-line react/destructuring-assignment -- directive added automatically by Shepherd migration
        if (this.props.pageViewId) {
          // eslint-disable-next-line react/destructuring-assignment -- directive added automatically by Shepherd migration
          return this.props.pageViewId;
        }

        if (typeof window !== 'undefined' && window.nwa != null) {
          return window.nwa.getGlobalProp('pageViewId');
        }

        return null;
      }
    }, {
      key: "constructURL",
      value: function constructURL() {
        var _window, _window$location;

        // eslint-disable-next-line react/destructuring-assignment -- directive added automatically by Shepherd migration
        var parsedUrl = uri.parse(this.props.href);
        var existingProps = qs.parse(parsedUrl.query);

        var props = _objectSpread(_objectSpread(_objectSpread({}, existingProps), this.props.eventProps), {}, {
          // eslint-disable-next-line react/destructuring-assignment -- directive added automatically by Shepherd migration
          header_pageViewId: this.state.header_pageViewId,
          source_url: (_window = window) === null || _window === void 0 ? void 0 : (_window$location = _window.location) === null || _window$location === void 0 ? void 0 : _window$location.href
        });

        var keys = Object.keys(props);

        if (keys.length) {
          // Support nested props to 1 level deep
          keys.forEach(function (key) {
            if (_isPlainObject(props[key])) {
              var subKeys = Object.keys(props[key]);
              subKeys.forEach(function (subKey) {
                props["".concat(key, "_").concat(subKey)] = props[key][subKey];
              });
              delete props[key];
            }
          }); // Support legacy `pos` prop as a duplicate of productPosition

          if (props.pos == null && props.clickHeader_productPosition) {
            props.pos = props.clickHeader_productPosition;
          }

          delete parsedUrl.search; // Delete `search` so `format` uses `query` instead

          parsedUrl.query = props;
          return uri.format(parsedUrl);
        } // eslint-disable-next-line react/destructuring-assignment -- directive added automatically by Shepherd migration


        return this.props.href;
      }
    }, {
      key: "render",
      value: function render() {
        var _this$props = this.props,
            eventProps = _this$props.eventProps,
            pageViewId = _this$props.pageViewId,
            href = _this$props.href,
            component = _this$props.component; // eslint-disable-next-line react/destructuring-assignment -- directive added automatically by Shepherd migration

        var Component = component || defaultComponent;
        var onClickURL = this.constructURL(href, eventProps, pageViewId);

        var props = _objectSpread(_objectSpread({}, this.props), {}, {
          // eslint-disable-next-line no-return-assign
          onClick: function onClick() {
            var _window2;

            return (_window2 = window) === null || _window2 === void 0 ? void 0 : _window2.open(onClickURL, '_blank');
          },
          href: onClickURL,
          // eslint-disable-next-line react/destructuring-assignment -- directive added automatically by Shepherd migration
          target: '_blank',
          role: 'link',
          component: 'button'
        });

        delete props.eventProps;
        delete props.newWindow;
        delete props.pageViewId;
        delete props.dispatch;
        return /*#__PURE__*/React.createElement(Component, props);
      }
    }]);

    return ApplyNowClick;
  }(React.Component); // eslint-disable-next-line react/static-property-placement -- directive added automatically by Shepherd migration


  ApplyNowClick.defaultProps = {
    newWindow: true
  }; // eslint-disable-next-line react/static-property-placement -- directive added automatically by Shepherd migration

  ApplyNowClick.propTypes = {
    href: PropTypes.string.isRequired,
    // eslint-disable-next-line react/forbid-prop-types, react/require-default-props -- directive added automatically by Shepherd migration
    eventProps: PropTypes.object,
    newWindow: PropTypes.bool,
    // eslint-disable-next-line react/require-default-props -- directive added automatically by Shepherd migration
    pageViewId: PropTypes.string,

    /**
     * Use a custom component instead of the default 'a' html component.
     */
    // eslint-disable-next-line react/forbid-prop-types, react/require-default-props -- directive added automatically by Shepherd migration
    component: PropTypes.any
  };
  return ApplyNowClick;
};

export default wrapWithClickProps('button');
export { wrapWithClickProps };